import { useStaticQuery, graphql } from "gatsby";

export const useRoiCalculatorData = () => {
  const { contentfulComponentRoiCalculator } = useStaticQuery(graphql`
    query RoiCalculatorQuery {
      contentfulComponentRoiCalculator(
        id: {eq: "813ee0a2-2984-51d0-95a1-78b1e369c58f"}
      ) {
        internalName
        id
        contentful_id
        ticketsPerEmployee
        costSavingsPerTicket
        minsSavedPerEmployee
        hourlyRateProductivity
        approvalsPerEmployee
        timeSavedPerApproval
        hourlyRateApprovals
      }
    }
  `)
  return contentfulComponentRoiCalculator
}